<template>
    <div class="scenario-list-item">
        <div class="scenario-list-item-header content-container">
            <div class="scenario-list-image-container">
                <img
                        v-if="scenario.imageUrl"
                        v-bind:src="scenario.imageUrl"
                        class="scenario-list-image"
                />
            </div>

            <hr />
        </div>
        
        <div class="scenario-list-item-body content-container">
            <div class="scenario-list-item-content">
                <span class="scenario-list-item-title dmv-text dmv-text-primary dmv-text-large">
                    {{ scenario.name }}
                </span>
    
                    <span class="dmv-text dmv-text-secondary">
                    {{ scenario.description }}
                </span>

                <slot name="description-bottom"></slot>
            </div>
        </div>
        
        <div class="scenario-list-item-footer content-container">
            <slot name="bottom"></slot>
        </div>
    </div>
</template>

<script>
    export default {
        name: "scenario-list-item-base",
        props: {
            scenario: {
                type: Object,
                required: true,
                default: () => ({
                    name: '',
                    imageUrl: null,
                    description: ''
                })
            }
        }
    };
</script>

<style scoped src="../Style/scenario-list-item-base.scss" lang="scss">
</style>
